<template>
  <div slot="pop-body">
    <div class="my-pop-alert">
      <div class="my-pop-alert-top"><span>{{alarmsTitle1}}</span>
        <button class="my-pop-alert-top-btn" @click.prevent="changeTab">
          <img src="../../assets/images/mypooq/icon-alam-s.png"
               :class="alarmsTitle2 === '알림설정' ? 'alarms-image-show' : 'alarms-image-hide'"
               alt=""/>
          <span>{{alarmsTitle2}}</span>
        </button>
      </div>
      <alarms-setup v-if="alarmsTab === 'setup'"/>
      <alarm-list v-if="alarmsTab === 'list'"/>
    </div>
  </div>
</template>
<script>
import AlarmsSetup from '@/components/mypooq/AlarmsSetup'
import AlarmList from '@/components/mypooq/AlarmList'
export default {
  name: 'AlarmPopupBody',
  components: {
    AlarmsSetup,
    AlarmList
  },
  data () {
    return {
      alarmsTab: 'list',
      alarmsTitle1: '알림함',
      alarmsTitle2: '알림설정'
    }
  },
  methods: {
    changeTab () {
      if (this.alarmsTab === 'setup') {
        this.alarmsTab = 'list'
        this.alarmsTitle1 = '알림함'
        this.alarmsTitle2 = '알림설정'
      } else {
        this.alarmsTab = 'setup'
        this.alarmsTitle1 = '알림설정'
        this.alarmsTitle2 = '알림함'
      }
    }
  }
}
</script>
